<template>
  <transition name="slide-fade">
    <div v-if="show"
         class="mobileNav_container">
      <div v-for="(menu) in menuLists"
           v-bind:key="menu.path"
           :data-path="menu.path"
           v-on:click="setActive(menu.path)"
           class="pMenus">{{menu.label}}</div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    menuLists: {
      type: Array,
      default: () => {
        return []
      }
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  // mounted() {
  //   this.setActive(this.$route.path, false)
  // },
  watch: {
    show(n, o) {
      if (n) {
        this.$nextTick(() => {
          this.setActive(this.$route.path, false)
        })
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    setActive(path, istip = true) {
      const ms = Array.from(document.querySelectorAll('.pMenus'))
      ms.map(e => {
        const p = e.dataset.path
        if (e.classList.contains('active')) {
          e.classList.remove('active')
        }
        if (path.indexOf(p) !== -1) {
          e.classList.add('active')
        }
      })
      if (istip) {
        this.goto(path)
      }
    },
    goto(path) {
      this.$emit('changePath')
      this.$router.push({ path })
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.mobileNav_container {
  border-top: 1px solid #dedede;
  width: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  background: #fff;
  margin-top: 0.9rem;
  padding: 0rem 0.2rem 0rem 0.56rem;
  text-align: left;
  .pMenus {
    font-size: 0.24rem;
    font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI",
      "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue",
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
    font-weight: 500;
    color: rgba(27, 27, 27, 1);
    line-height: 0.36rem;
    // margin-bottom: 0.5rem;
    padding: 0.36rem 0rem;
    &.active {
      color: #1dc3fe;
    }
  }
}
</style>
